export default {
    data() {
        return {
            idx: 0
        }
    },
    methods: {
        setIdx(idx) {
            this.idx = idx
        },
        previous(blocked = false) {
            if (this.idx > 0) {
                this.idx--
            } else if (!blocked) {
                this.idx = this.count - 1
            }
        },
        next(blocked = false) {
            if (this.idx < this.count - 1) {
                this.idx++
            } else if (!blocked) {
                this.idx = 0
            }
        }
    }
}